const styles = (theme) => ({
  addButtonWrapper: {
    paddingLeft: 0,
  },
  addButton: {
    color: theme.palette.primary.blackLight,
    background: theme.palette.primary.white,
    border: `1.5px solid ${theme.palette.primary.mint}`,
    padding: '12px 24px',
    maxHeight: '40px',
    textTransform: 'none',
    textDecoration: 'none',

    '&:hover': {
      borderColor: theme.palette.primary.greyBlack,
      textDecoration: 'none',
    },

    '&:active': {
      background: theme.palette.primary.whiteDark,
      borderColor: theme.palette.primary.greyBlack,
    },
  },
  addIcon: {
    fill: theme.palette.primary.darkBlack,
    transform: 'scale(1.5)',
  },
  addButtonText: {
    fontSize: '14px',
    lineHeight: '16px',
    fontWeight: '500',
    color: theme.palette.primary.greyBlack,
    textDecoration: 'unset',
    marginLeft: theme.spacing(1),
  },
  menu: {
    borderRadius: '8px',
  },
  menuList: {
    padding: 'unset',
    maxWidth: '100%',
    minWidth: '335px',
    borderRadius: '8px',
  },
  itemContainer: {
    padding: '14px 16px',
    columnGap: '8px',
  },
  itemIconContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '20px',
    minWidth: 'unset',
  },
  itemIcon: {
    width: 'unset',
    height: 'unset',
    fill: theme.palette.primary.darkBlack,
  },
  itemText: {
    fontSize: '14px',
    lineHeight: '24px',
    margin: 'unset',
  },
  itemTextBold: {
    fontWeight: 700,
  },
});

export default styles;
